import { ArrowLeft, Check, Download, Mail } from "lucide-react";
import { fmtDate } from "@/lib/adminApi";
import { StatusBadge } from "@/components/admin/StatusBadge";
import { SectionHeading } from "@/components/vendor/Brand";

export const RateValue = ({ room }) =>
  room.approved ? <span className="hx-approved"><Check size={14} /> Approved our estimate</span> : <span className="hx-strong">{room.rate || "—"}</span>;

const Info = ({ label, children, testId }) => (
  <div><dt>{label}</dt><dd data-testid={testId}>{children}</dd></div>
);

export const VendorDetail = ({ sub, onBack, onPdf, onResend, busy }) => (
  <div className="hx-fade" data-testid="vendor-detail">
    <div className="hx-toolbar">
      <button className="hx-btn hx-btn--ghost hx-btn--sm" onClick={onBack} data-testid="vendor-detail-back-button"><ArrowLeft size={14} /> All submissions</button>
      <div className="hx-toolbar__group">
        <button className="hx-btn hx-btn--ghost hx-btn--sm" onClick={() => onPdf(sub)} data-testid="vendor-detail-pdf-button"><Download size={14} /> Download PDF</button>
        <button className="hx-btn hx-btn--sm" disabled={busy} onClick={() => onResend(sub)} data-testid="vendor-detail-resend-button"><Mail size={14} /> Resend email</button>
      </div>
    </div>
    <h2 className="hx-title" style={{ marginTop: 20 }} data-testid="vendor-detail-company">{sub.vendor.company_name}</h2>
    <dl className="hx-kv">
      <Info label="Contact" testId="vendor-detail-contact">{sub.vendor.contact_name}</Info>
      <Info label="Email"><a href={`mailto:${sub.vendor.email}`} className="hx-link">{sub.vendor.email}</a></Info>
      <Info label="Phone">{sub.vendor.phone}</Info>
      <Info label="Submitted">{fmtDate(sub.created_at)}</Info>
      <Info label="Submission ID" testId="vendor-detail-id">{sub.submission_id}</Info>
      <Info label="Email status"><StatusBadge status={sub.email_status} testId="vendor-detail-email-status" /> <span className="hx-muted">({sub.email_attempts} attempt{sub.email_attempts === 1 ? "" : "s"})</span></Info>
      {sub.email_error && <Info label="Last email error" testId="vendor-detail-email-error">{sub.email_error}</Info>}
      <Info label="IP">{sub.ip}</Info>
    </dl>
    <section className="hx-section">
      <SectionHeading>Room Packages</SectionHeading>
      <table className="hx-table hx-table--stack">
        <thead><tr><th>Room Package / Max Size</th><th>Our Est.</th><th>Vendor Rate / OK</th></tr></thead>
        <tbody>
          {sub.rooms.map((r) => (
            <tr key={r.id}>
              <td data-label="Room"><div className="hx-strong">{r.label}</div><div className="hx-muted">{r.size}</div></td>
              <td data-label="Our Est." className="hx-est">{r.our_estimate}</td>
              <td data-label="Vendor Rate / OK" data-testid={`vendor-detail-room-${r.id}`}><RateValue room={r} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
    <section className="hx-section">
      <SectionHeading>Additional Services</SectionHeading>
      <table className="hx-table hx-table--stack">
        <thead><tr><th>Service</th><th>Our Est.</th><th>Vendor Rate</th></tr></thead>
        <tbody>
          {sub.services.map((s) => (
            <tr key={s.id}>
              <td data-label="Service">{s.label}</td>
              <td data-label="Our Est." className="hx-est">{s.our_estimate}</td>
              <td data-label="Vendor Rate" className="hx-strong" data-testid={`vendor-detail-service-${s.id}`}>{s.rate || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
    <section className="hx-section">
      <SectionHeading>Vendor Notes</SectionHeading>
      <p className="hx-static" style={{ whiteSpace: "pre-wrap" }} data-testid="vendor-detail-notes">{sub.notes || "—"}</p>
    </section>
  </div>
);
